import { getAppropriateRiskLimiter } from './';

/**
 * Round a number to 2 decimals.
 * This is intended for UI not for proper math.
 */
export function formatRiskRoundTwoDecimals(impact: number | string | undefined, cancerType?: string): string {
  const limiter = getAppropriateRiskLimiter(cancerType);
  const limitedImpact = limiter(impact);

  if (typeof limitedImpact === 'number') return `${Math.round(limitedImpact * 100) / 100}%`;
  if (typeof limitedImpact === 'string') {
    if (!isNaN(Number(limitedImpact))) return `${Math.round(Number(limitedImpact) * 100) / 100}%`;
    return limitedImpact;
  }
  return 'N/A';
}
